import NextLink from 'next/link';
import { ActionCard } from '@zopauk/web-ui';

export const EmailCard = ({ email }: Record<'email', string>) => (
  <ActionCard
    icon={<span className="material-symbols-outlined text-6xl! mt-3">mail</span>}
    data-automation="ZA.button-EmailUs"
    className="relative mb-6"
    href={`mailto:${email}`}
    title="Email us"
    as={NextLink}
  >
    <span className="font-semibold text-primary-focused mb-1">{email}</span>
    <p className="text-sm mb-3">We aim to answer in 2 days.</p>
  </ActionCard>
);
